class PPFrequentlyBoughtTogether extends HTMLElement {
  connectedCallback() {
    this.checkboxes = [...this.querySelectorAll('[data-fbt-check]')];
    this.total = this.querySelector('[data-fbt-total]');
    this.button = this.querySelector('[data-fbt-add]');
    this.status = this.querySelector('[data-fbt-status]');
    this.checkboxes.forEach((box) => box.addEventListener('change', () => this.update()));
    this.querySelectorAll('[data-fbt-variant]').forEach((select) => {
      select.addEventListener('change', () => this.changeVariant(select));
    });
    this.button?.addEventListener('click', () => this.add());
    this.update();
  }
  selected() { return this.checkboxes.filter((box) => box.checked && box.dataset.variantId); }
  changeVariant(select) {
    const card = select.closest('.pp-fbt-product');
    const option = select.selectedOptions[0];
    const checkbox = card?.querySelector('[data-fbt-check]');
    const price = card?.querySelector('[data-fbt-item-price]');
    const image = card?.querySelector('.pp-fbt-product__image');
    if (!option || !checkbox) return;
    checkbox.dataset.variantId = option.value;
    checkbox.dataset.price = option.dataset.price || '0';
    checkbox.disabled = option.dataset.available !== 'true';
    if (checkbox.disabled) checkbox.checked = false;
    if (price) price.textContent = option.dataset.priceFormatted || '';
    if (image && option.dataset.image) { image.src = option.dataset.image; image.srcset = option.dataset.image; }
    this.update();
  }
  update() {
    const selected = this.selected();
    const cents = selected.reduce((sum, box) => sum + Number(box.dataset.price || 0), 0);
    if (this.total) this.total.textContent = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style:'currency', currency:this.dataset.currency || 'USD' }).format(cents / 100);
    if (this.button) {
      this.button.disabled = selected.length === 0;
      const label = this.button.dataset.label || 'Add selected to cart';
      this.button.textContent = `${label} (${selected.length})`;
    }
  }
  async add() {
    const selected = this.selected();
    if (!selected.length) return;
    this.button.disabled = true;
    this.status.textContent = this.dataset.loading || 'Adding…';
    this.status.dataset.state = '';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map((box)=>({id:Number(box.dataset.variantId),quantity:1}))})});
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add products.');
      this.status.textContent = this.dataset.success || 'Added to cart.';
      this.status.dataset.state = 'success';
      document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true}));
      window.location.href = `${window.Shopify.routes.root}cart`;
    } catch (error) {
      this.status.textContent = error.message;
      this.status.dataset.state = 'error';
      this.button.disabled = false;
    }
  }
}
if (!customElements.get('pp-frequently-bought-together')) customElements.define('pp-frequently-bought-together', PPFrequentlyBoughtTogether);

